import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  process.env.NODE_ENV === "development" && console.error('Missing Supabase environment variables');
}

// Custom fetch that clones the response before reading
// Prevents "body stream already read" errors in the Supabase SDK
const safeFetch = (url, options = {}) => {
  return fetch(url, options).then(response => response.clone());
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    fetch: safeFetch
  }
});
